module.exports = __webpack_public_path__ + "static/fullmenu.282de745.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/fullmenu.pdf
// module id = 308
// module chunks = 114276838955818